// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__37hEc","Logo":"Footer_Logo__2lPwH","socialIcon":"Footer_socialIcon__1dkGY"};